import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { Constants } from '@shared/models/common/constants';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';
import { ElasticSearchQueryBody } from '@shared/models/common/elasticsearch-query-body.model';
import { AbandonedMine } from '@shared/models/records/abandoned-mine.model';
import { Assessment } from '@shared/models/records/assessment.model';
import { DrillHole } from '@shared/models/records/drill-hole.model';
import { MineralInventory } from '@shared/models/records/mineral-inventory.model';
import { Publication } from '@shared/models/records/publication.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ElasticsearchQueryService {

  router: Router;

  constructor(private http: HttpClient, injector: Injector) { 
    this.router = injector.get(Router);
  }

  get httpOptions(): any {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key" : environment.serviceSubscriptionKey
      }),
    };
  }

  getAuthors(): Observable<any> {
    var elasticSearchQueryBody: ElasticSearchQueryBody = {
      size: 10000
    };
    var postRequest : any = {
      indexes: "publication-author",
      body: JSON.stringify(elasticSearchQueryBody)
    }

    return this.http.post(environment.apim_url, postRequest, this.httpOptions) as Observable<any>;
  }

  getSeries(): Observable<any> {
    var elasticSearchQueryBody: ElasticSearchQueryBody = {
      size: 10000
    };
    var postRequest : any = {
      indexes: "publication-series",
      body: JSON.stringify(elasticSearchQueryBody)
    }

    return this.http.post(environment.apim_url, postRequest, this.httpOptions) as Observable<any>;
  }

  getTownship(): Observable<any> {
    var elasticSearchQueryBody: ElasticSearchQueryBody = {
      size: 10000
    };
    var postRequest : any = {
      indexes: "township",
      body: JSON.stringify(elasticSearchQueryBody)
    }

    return this.http.post(environment.apim_url, postRequest, this.httpOptions) as Observable<any>;
  }

  getNts(): Observable<any> {
    var elasticSearchQueryBody: ElasticSearchQueryBody = {
      size: 10000
    };
    var postRequest : any = {
      indexes: "nts",
      body: JSON.stringify(elasticSearchQueryBody)
    }

    return this.http.post(environment.apim_url, postRequest, this.httpOptions) as Observable<any>;
  }

  getCommodity(): Observable<any> {
    var elasticSearchQueryBody: ElasticSearchQueryBody = {
      size: 10000
    };
    var postRequest : any = {
      indexes: "commodity",
      body: JSON.stringify(elasticSearchQueryBody)
    }

    return this.http.post(environment.apim_url, postRequest, this.httpOptions) as Observable<any>;
  }

  getPersistentRecord(index: string, id: string) {
    var fieldName = "abandoned_mine_identifier";
    if(index == DatabaseIndexNameType.assessment) {
      fieldName = "file_id";
    } else if(index == DatabaseIndexNameType.mineralInventory) {
      fieldName = "mdi_ident";
    } else if(index == DatabaseIndexNameType.drillHoles) {
      fieldName = "tech_id";
    } else if(index == DatabaseIndexNameType.publication) {
      fieldName = "publ_num";
    }

    var body = {
      query: {
        bool: {
          must: [
            {
              match_phrase: {
                [fieldName]: id,
              }
            }
          ]
        }
      }
    };

    var postRequest : any = {
      indexes: index,
      body: JSON.stringify(body)
    }

    this.http
      .post(environment.apim_url, postRequest, this.httpOptions)
      .subscribe((res: any) => {

        if(res.hits.hits.length > 0) {
          var recordData = res.hits.hits[0]._source;
          var record: any;

          if(index == DatabaseIndexNameType.assessment) {
            record = new Assessment(recordData);
          } else if(index == DatabaseIndexNameType.mineralInventory) {
            record = new MineralInventory(recordData);
          } else if(index == DatabaseIndexNameType.drillHoles) {
            record = new DrillHole(recordData);
          } else if(index == DatabaseIndexNameType.publication) {
            record = new Publication(recordData);
          } else {
            record = new AbandonedMine(recordData);
          }

          if(record) {
            this.router.navigate(['/' + index, id], { state: { data: record}});
          }
        }
      });
  }

  getCorrectionSuggestions(searchTerms: string){
    var body = {
      suggest: {
        text: searchTerms,
        simple_phrase: {
          phrase: {
            field: "content",
            confidence: 1.5,
            max_errors: 2,
            size: 3,
            direct_generator: [{
              field: "content",
              suggest_mode: "popular",
              min_word_length: 2,
              min_doc_freq: 5,
              prefix_length: 0 // Added for User Story #59420
            }]
          }
        }
      }
    }

    var postRequest : any = {
      indexes: Constants.DOCUMENTS.toString(),
      body: JSON.stringify(body)
    }

    return this.http.post(environment.apim_url, postRequest, this.httpOptions) as Observable<any>;
  }

  getIndexCompletionSuggestions(index: string, body: string) {
    var postRequest : any = {
      indexes: index,
      body: JSON.stringify(body)
    }

    return this.http.post(environment.apim_url, postRequest, this.httpOptions) as Observable<any>;
  }

}
